<template>
  <div
    class="w-full bg-white border border-[#E5E7EB] rounded-xl pt-5 px-5 pb-0 shadow-sm text-left"
  >
    <h3 class="text-[20px] font-bold text-textPrimary mb-2 tracking-tight">
      {{ title }}
    </h3>

    <div v-if="events.length" class="relative pb-5">
      <div class="absolute left-[4px] top-[10px] bottom-0 w-[2px] bg-[#CBD5E1] z-0"></div>

      <div
        v-for="(event, index) in events"
        :key="index"
        class="flex gap-4 relative z-10 mb-2 last:mb-0"
      >
        <div class="relative flex flex-col items-center shrink-0">
          <div
            class="w-2.5 h-2.5 rounded-full mt-1.5 z-10"
            :class="event.isPrimary ? 'bg-[#34818F]' : 'bg-[#323232]'"
          ></div>
        </div>

        <div class="flex flex-col">
          <p class="text-[15px] text-[#323232] leading-snug">
            <span class="font-bold mr-1.5">{{ event.date }}</span>
            <span class="font-normal">{{ event.description }}</span>
          </p>
          <p class="text-[13px] text-gray-500 mt-0.5 font-normal tracking-wide">
            {{ event.time }}
          </p>
          <div v-if="event.links?.length" class="mt-0.5 flex flex-wrap gap-x-3">
            <button
              v-for="link in event.links"
              :key="link.containerId"
              type="button"
              class="text-[13px] font-semibold text-primary30 underline"
              :data-testid="`history-event-link-${link.containerId}-button`"
              @click="openLink(link.containerId)"
            >
              {{ link.label }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex flex-col items-center justify-center py-6 pb-8 text-center">
      <v-icon :size="40" color="#CBD5E1" class="mb-2">{{ mdiClockOutline }}</v-icon>
      <p class="text-sm text-gray-400 font-medium">{{ emptyText }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { mdiClockOutline } from '@mdi/js'
import { useErrorToast } from '@/composables/useErrorToast'
import { openDsAttendanceContainerInNewTab } from '@/utils/openDsAttendanceContainer'

export interface HistoryEventLink {
  label: string
  containerId: number
}

export interface HistoryEvent {
  date: string
  description: string
  time: string
  isPrimary?: boolean
  /** Spec 2026-09-24 §7 — registro contraparte de uma sobrescrita de perna. */
  links?: HistoryEventLink[]
}

defineProps({
  title: {
    type: String,
    default: 'Histórico'
  },
  events: {
    type: Array as PropType<HistoryEvent[]>,
    required: true,
    default: () => []
  },
  emptyText: {
    type: String,
    default: 'Nenhum registro encontrado.'
  }
})

const { notifyError } = useErrorToast()

async function openLink(containerId: number) {
  try {
    await openDsAttendanceContainerInNewTab(containerId)
  } catch (error) {
    notifyError(error, 'Não foi possível abrir o registro.')
  }
}
</script>

<style scoped></style>
